import {
  Box,
  Grid,
  Button,
  Modal,
  Fade,
  Divider,
  FormControl,
  RadioGroup,
  FormLabel,
  FormControlLabel,
  Radio,
  Checkbox,
} from "@mui/material";
import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  GetUsers,
  GetUserCountries,
  GetRoles,
  UpdateAndSaveUser,
} from "../centralAdminSlice";
import MultiSelectCountry from "./MultiSelectCountry_updated";
import TextField from "@mui/material/TextField";
import MenuItem from "@mui/material/MenuItem";
import Alert from "../../../components/ui/Alert";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 600,
  bgcolor: "background.paper",
  border: "1px solid #000",
  boxShadow: 24,
  borderRadius: 3,
  p: 4,
};

export default function AddUserModal(props) {
  const dispatch = useDispatch();
  const centralAdmin = useSelector((state) => state.centralAdmin);
  const { countries, roles, getUserDataInitially, selectedCountry, selectedRole } =
    centralAdmin;

  const [validate, setValidate] = useState({
    emailValidateMessage: "Please enter Email",
    firstnameValidated: false,
    lastnameValidated: false,
    emailValidated: false,
  });

  const [alert, setAlert] = useState({
    alertSeverity: "",
    alertDisplay: false,
    alertMessage: "",
  });

  const displayAlert = (showAlert, alertMessage) => {
    setAlert({
      alertSeverity: "warning",
      alertDisplay: `${showAlert}`,
      alertMessage: `${alertMessage}`,
    });
  };

  useEffect(() => {
    //Check if any of the dropdown are false and then set alertDisplay to false
    const isAnyKeyValueFalse = (o) => !!Object.keys(o).find((k) => !o[k]);

    if (isAnyKeyValueFalse(validate)) {
      setAlert({ ...Alert, alertDisplay: false });
    }
  }, [validate]);

  useEffect(() => {
    let obj = {
      roleID: 0,
      countryID: "",
      searchText: "",
    };

    dispatch(GetUsers(obj));
  }, []);

  useEffect(() => {
    if (countries.length <= 0) {
      dispatch(GetUserCountries({ method: "Get" }));
    }
  }, []);

  useEffect(() => {
    if (roles.length <= 0) {
      dispatch(GetRoles({ method: "Get" }));
    }
  }, []);

  const InsertUser = () => {
    let geoIdArray = countries.map((item) =>
      updatedGeoNameList.includes(item.countryName) ? item.countryID : null
    );

    let filteredGeoIdArray = geoIdArray.filter((item) => item !== null);
    if (filteredGeoIdArray == "" || filteredGeoIdArray == []) {
      filteredGeoIdArray = countries.map((item) => item.countryID);
    }

    let msg = "";
    const postData = [
      {
        firstName: firstName,
        lastName: lastName,
        email: email,
        roleID: role,
        geoID: filteredGeoIdArray.toString(),
        activeFlag: isActive == "Active" ? "Y" : "N",
        notifyByEmailFlag: notifyByEmail == "Yes" ? true : false,
        restrictedAccess: isRestrictedAccess ? 1 : 0,
        isInsert: "Insert",
      },
    ];

    if (validate.emailValidateMessage) msg = validate.emailValidateMessage;
    else msg = "Please enter Email";

    if (!validate.firstnameValidated)
      displayAlert(true, "Please enter First Name");
    else if (!validate.lastnameValidated)
      displayAlert(true, "Please enter Last Name");
    else if (!validate.emailValidated) displayAlert(true, msg);
    else {
      dispatch(UpdateAndSaveUser(postData));
      handleClose();
      if (selectedCountry != "" && selectedRole != "") props.handleDisplay();
    }
  };

  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [role, setRole] = useState("1");
  const [notifyByEmail, setNotifyByEmail] = useState("Yes");
  const [isActive, setIsActive] = useState("Active");
  const [isRestrictedAccess, setIsRestrictedAccess] = useState(false);

  const [geoIdList, setGeoIdList] = useState("");

  const [updatedGeoNameList, setUpdatedGeoNameList] = useState("");

  const handleSelect = (event) => {
    setRole(event.target.value);
  };

  function handleCountrySelection(data) {
    setUpdatedGeoNameList(data);
  }

  const handleFirstNameChange = (event) => {
    setFirstName(event.target.value);
    if (event.target.value) {
      setValidate({
        ...validate,
        firstnameValidated: true,
      });
    } else {
      setValidate({
        ...validate,
        firstnameValidated: false,
      });
    }
  };

  const handleLastNameChange = (event) => {
    setLastName(event.target.value);
    if (event.target.value) {
      setValidate({
        ...validate,
        lastnameValidated: true,
      });
    } else {
      setValidate({
        ...validate,
        lastnameValidated: false,
      });
    }
  };

  const handleEmailChange = (event) => {
    setEmail(event.target.value);

    let input = event.target.value;
    let isValidEmail = false;
    let msg = "Please enter Email";
    var validRegex =
      /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;

    if (event.target.value) {
      isValidEmail = true;
      msg = "";
    } else {
      isValidEmail = false;
      msg = "Please enter Email";
    }

    if (input.match(validRegex)) {
      isValidEmail = true;
      msg = "";
    } else {
      isValidEmail = false;
      msg = "Enter a valid Email";
    }

    if (input.endsWith("@amgen.com")) {
      isValidEmail = true;
      msg = "";
    } else {
      isValidEmail = false;
      msg = "Email should end with @amgen.com";
    }

    var emailvalidate = getUserDataInitially.filter((x) => x.email == input.trim());
    if (emailvalidate.length > 0) {
      isValidEmail = false;
      msg = "Email already exists,cannot create record";
    }

    if (isValidEmail) {
      setValidate({
        ...validate,
        emailValidated: true,
        emailValidateMessage: "",
      });
    } else {
      setValidate({
        ...validate,
        emailValidated: false,
        emailValidateMessage: msg,
      });
    }
  };

  const handleAddUserIconPress = (event) => {
    setValidate({
      firstnameValidated: false,
      lastnameValidated: false,
      emailValidated: false,
    });

    setAlert({
      alertSeverity: "",
      alertDisplay: false,
      alertMessage: "",
    });

    setFirstName("");
    setLastName("");
    setEmail("");
    setRole("1");
    setNotifyByEmail("Yes");
    setIsActive("Active");
    setIsRestrictedAccess(false);
    handleOpen();
  };

  return (
    <div>
      <Button
        sx={{ marginLeft: "calc(100% - 120px)", mt: -10 }}
        variant="contained"
        onClick={handleAddUserIconPress}
        size="large"
      >
        Add User
      </Button>
      {alert.alertDisplay && (
        <Alert message={alert.alertMessage} severity={alert.alertSeverity} />
      )}
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={open}
        onClose={handleClose}
        closeAfterTransition
      >
        <Fade in={open}>
          <Box sx={style}>
            <h3>Add User</h3>
            <Divider />
            <div>
              <Grid container spacing={2}>
                <Grid item xs={6}>
                  <FormControl id="left-control-group">
                    <label>
                      First Name
                      <TextField
                        variant="outlined"
                        value={firstName}
                        onChange={handleFirstNameChange}
                        fullWidth
                        required
                        size="small"
                      ></TextField>
                    </label>
                    <label>
                      Email
                      <TextField
                        variant="outlined"
                        value={email}
                        onChange={handleEmailChange}
                        fullWidth
                        required
                        size="small"
                      ></TextField>
                    </label>
                    <label>
                      QMS Role
                      <TextField
                        variant="outlined"
                        select={roles.length > 0 ? true : false}
                        value={roles.length > 0 ? role : ""}
                        onChange={handleSelect}
                        fullWidth
                        size="small"
                      >
                        {roles.length > 0
                          ? roles.map((role, index) => {
                              return (
                                <MenuItem key={role.roleID} value={role.roleID}>
                                  {role.roleName}
                                </MenuItem>
                              );
                            })
                          : null}
                      </TextField>
                    </label>
                    <FormLabel id="row-radio-button-id">
                      Notify By Email
                    </FormLabel>
                    <RadioGroup
                      id="row-radio-buttons"
                      row
                      area-labelledby="row-radio-buttons"
                      name="row-radio-buttons-group"
                      defaultValue={notifyByEmail}
                      onChange={(e) => setNotifyByEmail(e.target.value)}
                    >
                      <FormControlLabel
                        value="Yes"
                        control={<Radio size="small" />}
                        label="Yes"
                      />
                      <FormControlLabel
                        value="No"
                        control={<Radio size="small" />}
                        label="No"
                      />
                    </RadioGroup>
                  </FormControl>
                  <label>
                    Country
                    <MultiSelectCountry
                      geoIdList={geoIdList}
                      countryList={countries}
                      sendDataToParent={handleCountrySelection}
                      isEdit={true}
                    ></MultiSelectCountry>
                  </label>
                </Grid>
                <Grid item xs={6}>
                  <FormControl id="right-control-group">
                    <label>
                      Last Name
                      <TextField
                        variant="outlined"
                        value={lastName}
                        onChange={handleLastNameChange}
                        fullWidth
                        required
                        size="small"
                      ></TextField>
                    </label>
                    <FormLabel id="column-radio-button-id">
                      In Active Flag
                    </FormLabel>
                    <RadioGroup
                      aria-labelledby="column-radio-buttons"
                      id="column-radio-buttons"
                      name="column-radio-buttons"
                      defaultValue={isActive}
                      onChange={(e) => setIsActive(e.target.value)}
                    >
                      <FormControlLabel
                        value="Active"
                        control={<Radio size="small" />}
                        label="Active"
                      />
                      <FormControlLabel
                        value="InActive"
                        control={<Radio size="small" />}
                        label="InActive"
                      />
                      <FormControlLabel
                        value="First Time User"
                        control={<Radio size="small" />}
                        label="FirstTime"
                      />
                    </RadioGroup>
                    <Box mt={2}></Box>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={isRestrictedAccess}
                          onChange={(e) =>
                            setIsRestrictedAccess(e.target.checked)
                          }
                          inputProps={{ "aria-label": "controlled" }}
                        />
                      }
                      label="Restricted Access"
                    />
                  </FormControl>
                </Grid>
              </Grid>
            </div>
            <Divider />
            <div style={{ padding: "10px" }}>
              <Button variant="contained" onClick={InsertUser} size="large">
                Insert
              </Button>
            </div>
          </Box>
        </Fade>
      </Modal>
    </div>
  );
}
